module.exports = __webpack_public_path__ + "static/media/Techies.e56b115d.png";